import styled from 'styled-components';
import { getFontSize } from '../utils/getFont';

const RadioContainer = styled.div`
  display: block;
  background-color: var(--background-alt);
  border-radius: 6px;
  border: ${({ bordered }) => (bordered ? '2px solid var(--text)' : 'none')};
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  ${({ marginTop }) => (marginTop ? `margin-top: ${marginTop}px;` : '')}

  ${({ horizontal }) =>
    horizontal &&
    `
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    
    @media (max-width: 470px) {
      justify-content: space-between;
    }
  `}

  label {
    user-select: none;
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
    color: var(--text);
    ${({ fontSize }) => getFontSize(fontSize)}

    input[type='radio'] {
      margin-right: 8px;
      accent-color: var(--primary);
      cursor: pointer;
      transform: scale(1.25);
    }

    &:hover {
      background-color: var(--background-hover);
    }
  }
`;

export const Radio = ({
  className,
  options = [],
  label,
  name,
  value,
  onChange,
  horizontal,
  fontSize = 4,
  maxWidth = '100%',
  bordered,
  marginTop = 0,
}) => {
  const handleChange = (e) => {
    if (onChange) onChange(e.target.value);
  };

  return (
    <RadioContainer
      className={className}
      bordered={bordered}
      fontSize={fontSize}
      marginTop={marginTop}
      maxWidth={maxWidth}
      horizontal={horizontal}
    >
      {label && <label>{label}</label>}
      {options.map((opt) => (
        <label key={opt.value}>
          <input type="radio" name={name} value={opt.value} checked={value === opt.value} onChange={handleChange} />
          {opt.label}
        </label>
      ))}
    </RadioContainer>
  );
};
